import { render, staticRenderFns } from "./test-card.vue?vue&type=template&id=7d7598ce&scoped=true&"
import script from "./test-card.vue?vue&type=script&lang=js&"
export * from "./test-card.vue?vue&type=script&lang=js&"
import style0 from "./test-card.vue?vue&type=style&index=0&id=7d7598ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7598ce",
  null
  
)

export default component.exports